import { Alerts } from "../../../utility/types/widgets/types";

(function () {
    var $body: JQuery<HTMLElement> = $('body'),
        alerts: Alerts | null = null;
    // isMobile = false; // variable use to determine if responsive mode is on or off
    
    function createAndAppendInput(name, value, form) {
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = name;
        inp.value = value;
        form.append(inp);
    }

    alerts = {
        $target: null,
        $toggle: null,

        init: function () {
            alerts.$toggle = $("[name='markall']");

            //alerts.on.build();
            alerts.control();

            $(document).ready(function () {
                var href: string = location.href,
                    test: string = '?isAddCitationAlert=true',
                    tabToOpen: string | null = null;

                if (href.indexOf(test) >= 0) {
                    tabToOpen = href.split(test)[1];
                    if (tabToOpen === '#citAlerts') {
                        $('#pane-citation-con').trigger('click');
                    }
                }
            });
        },
        control: function () {
            var checkboxes: JQuery<HTMLElement> | null = null,
                markall: JQuery<HTMLElement> | null = null;

            $body.on('click', '[name="markall"]', function (e) {
                alerts.$target = $(this).closest('.alert__list');
                checkboxes = alerts.$target.find('[type="checkbox"]');
                checkboxes.prop('checked', $(this).prop('checked'));
            });

            $body.on('click', '.alert__list [type="checkbox"]', function (e) {
                if (!$(this).prop('checked')) {
                    markall = $(this).closest('form').find('[name="markall"]');
                    markall.prop('checked', false);
                }
                $(this).prop('checked', $(this).prop('checked'));
            });

            $body.on('click', '[name="groupAll"]', function (e) {
                alerts.$target = $(this).closest('.accordion-tabbed__tab');
                checkboxes = alerts.$target.find('[type="checkbox"]');
                checkboxes.prop('checked', $(this).prop('checked'));
            });

            $body.on('change', '.alert__freq', function (e) {
                alerts.on.frequency_change($(this));
            });

            $body.on('change', '.alertSort', function (e) {
                alerts.on.sorting_change($(this));
            });

            $body.on('click', '.js__citActions', function (e) {
                alerts.on.checkboxCheck($(this));
                alerts.on.cit_actions_change($(this));
            });
        },

        on: {
            build: function () {},
            error_msg: function () {
                alert('Please select one publication at least');
            },
            frequency_change: function ($el: JQuery<HTMLElement>) {
                var form: JQuery<HTMLElement> = $el.parents('form'),
                    updateAxa: number = form.find('input[name=updateAxa]').length;

                form.find('input[name=action]').val(''); //clear the delete field
                if (!updateAxa) createAndAppendInput('updateAxa', 'true', form);
                // form.submit();
            },
            sorting_change: function ($el: JQuery<HTMLElement>) {
                const sortBy: any = $el.val(),
                    elId: string = $el.closest("[role='tabpanel']").attr('id'),
                    activeTab: string = `#${elId}`,
                    submitForm: string = `
                        <form action="/action/showAlertSettings">
                            <input type="hidden" name="type" value="citation" />
                            <input type="hidden" name="menuTab" value="Alerts"/>
                            <input type="hidden" name="sortBy" value="${sortBy}"/>
                        </form>`;

                sessionStorage.setItem('activeTab', activeTab);
                $(submitForm).appendTo('body').submit();
            },
            cit_actions_change: function ($el: JQuery<HTMLElement>) {
                const form: JQuery<HTMLElement> = $el.closest('form'),
                    val: string = $el.data('value');

                if (!val) return;

                if (!$('input[type=checkbox][name="citId"]:checked').length) {
                    alerts.on.error_msg();
                    return;
                }

                form.find('input[name=action]').val(val);

                if ($el.closest('.dropBlock__holder').length) UX.dropBlock.on.hide();
                const elId: string = $el.closest("[role='tabpanel']").attr('id'),
                    activeTab: string = `#${elId}`;

                sessionStorage.setItem('activeTab', activeTab);
                
                (form.get(0) as HTMLFormElement).submit();
            },
            checkboxCheck: function ($el: JQuery<HTMLElement>) {
                var $tr: JQuery<HTMLElement> = $el.parents('tr'),
                    $checkbox: JQuery<HTMLElement> = $tr.find('[type="checkbox"]'),
                    $jfccheckbox: JQuery<HTMLElement> = $tr.find('.jcf-checkbox');

                $checkbox.prop('checked', true);
                $jfccheckbox.addClass('jcf-checked');
            },
        },
    };

    UX.alerts = alerts; // add to global namespace
})();
